import { Entity } from '@debbie/common/dist/index.js';
import { InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import { replyRecipient, replySubject, } from '@debbie/common/dist/interactions/reply.js';
import { sortBy } from '@debbie/common/dist/util/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useInteractionsByReference } from '@debbie/cortex/dist/interactions/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Email from '../Email/index.js';
import { extractIds, findRelevantEmails } from '../Email/thread-utils.js';
import { CornerUpLeft, X } from '../Icons/index.js';
import { EmailInteraction } from '../interactions/index.js';
import Loading from '../Loading.js';
import Panel from '../Panel.js';
import Timestamp from '../Timestamp.js';
const EmailThread = (props) => {
    const interactions = useInteractionsByReference(Entity.Case, props.caseId, true);
    const lang = useSelector((s) => s.lang);
    const [replyingTo, setReplyingTo] = useState(null);
    if (!h.hasData(interactions) || interactions.data == null) {
        return React.createElement(Loading, null);
    }
    const emails = sortBy(interactions.data.filter((inter) => inter.type === InteractionType.Email), (inter) => new Date(inter.createdAt).getTime());
    const mainEmail = emails.find((inter) => inter.id === props.referenceInteraction);
    if (mainEmail == null) {
        return React.createElement("div", null, "No email referenced");
    }
    // Assign synthetic imapId to pending emails so they can participate in thread display
    for (const email of emails) {
        if (email.state === OutgoingState.PENDING && !email.details.imapId) {
            email.details.imapId = `<${email.id}@synthetic.local>`;
        }
    }
    const relevantEmails = findRelevantEmails(emails, mainEmail);
    let items = [];
    for (const email of relevantEmails) {
        const refs = extractIds(email.details.references ?? '');
        refs.reverse();
        let count = 0;
        for (const ref of refs) {
            if (items.find((item) => typeof item === 'object' &&
                (item.details.imapId ?? '').trim() === ref)) {
                break;
            }
            console.log(refs, emails.map((x) => x.details.imapId));
            count += 1;
        }
        if (count > 0) {
            // Uncomment to enable missing emails shown in UI
            // items.push(count)
        }
        items.push(email);
    }
    items.reverse();
    return (React.createElement(Wrapper, null, items.map((email) => {
        if (typeof email === 'number') {
            return (React.createElement(Panel, null,
                "Kunne ikke finde ",
                email,
                " ",
                email === 1 ? 'email' : 'emails'));
        }
        const isReference = email.id === props.referenceInteraction;
        const beingRepliedTo = replyingTo === email.id;
        return (React.createElement(React.Fragment, null,
            beingRepliedTo && (React.createElement(Panel, { header: React.createElement(Header, null,
                    React.createElement("span", null, lang.interactions.reply),
                    React.createElement(Close, { onClick: () => {
                            setReplyingTo(null);
                        } })) },
                React.createElement(EmailInteraction, { referenceId: email.referenceId, referenceType: Entity.Case, emailTo: replyRecipient(email.details), emailToEditable: true, replyingToInteractionId: replyingTo, defaultSubject: replySubject(email.details.subject, lang.interactions.replyPrefix || 'Re:'), 
                    /* defaultContent={`<br/><br/>${createLine(email)}<br/>${
                      email.details.html
                        ? extractBody(email.details.html)
                        : `${email.details.body}`
                    }`} */
                    onSent: () => {
                        setReplyingTo(null);
                    } }))),
            React.createElement(HighLightPanel, { isReference: isReference, header: React.createElement(Header, null,
                    React.createElement("span", null,
                        lang.interactions[email.direction],
                        " -",
                        ' ',
                        React.createElement(Timestamp, { date: email.createdAt })),
                    React.createElement(Reply, { onClick: () => {
                            setReplyingTo(email.id);
                        }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.interactions.reply })) },
                React.createElement(EmailComp, { interaction: email }))));
    })));
};
const Wrapper = styled.div `
  background: ${THEME.BACKGROUND};
  padding: 1em;
`;
const EmailComp = styled(Email) `
  margin-bottom: 1em;
`;
const HighLightPanel = styled(Panel) `
  border-bottom: ${(props) => props.isReference ? '5px solid rgba(32, 13, 84, 0.6)' : 'none'};
`;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Reply = styled(CornerUpLeft) `
  border-radius: 10000px;
  padding: 0.5em;
  width: 2em;
  height: 2em;
  background: white;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;
const Close = styled(X) `
  border-radius: 10000px;
  padding: 0.5em;
  width: 2em;
  height: 2em;
  background: white;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`;
export default EmailThread;
//# sourceMappingURL=EmailThread.js.map